import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const SearchField = () => {
    const navigate = useNavigate();

    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dataFetched, setDataFetched] = useState(false);

    const fetchData = async (query) => {
        setLoading(true);
        setDataFetched(false);
        try {
            let search_string = removePunctuationAndAccents(query.toLowerCase());
            let url = process.env.REACT_APP_BACKEND_URL + `/api/v1/search_games?name=${search_string}`;
            const response = await axios.get(url);
            setResults(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setLoading(false);
        setDataFetched(true);
    };

    // execute fetching 0.5s after user stops typing - optimization
    const debounce = (func, delay) => {
        let debounceTimer;
        return (...args) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const debouncedFetchData = useCallback(debounce(fetchData, 500), []);

    useEffect(() => {
        if (query) {
            debouncedFetchData(query);
        } else {
            setResults([]);
            setDataFetched(false);
        }
    }, [query, debouncedFetchData]);

    const handleChange = (event) => {
        setQuery(event.target.value);
    };

    const handleClick = (item) => {
        navigate(`/game/${item.game_id}`);
    };

    function removePunctuationAndAccents(str) {
        const normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const cleanStr = normalizedStr.replace(/[^\w\s]/gi, "");
        return cleanStr;
    }

    return (
        <div className="container mt-4">
            <a style={{ color: 'white' }}>Search for your favorite game:</a>
            <div className="input-group">
                <input
                    type="text"
                    className="form-control search-input"
                    value={query}
                    onChange={handleChange}
                    placeholder="Type game name here..."
                />
                <div className="input-group-append spinner-container">
                    {loading && (
                        <div className="spinner-border text-light ms-2" role="status">
                            <span className="sr-only"></span>
                        </div>
                    )}
                </div>
            </div>
            {!loading && dataFetched && results.length === 0 && (
                <div className="alert alert-info" role="alert">
                    No data available.
                </div>
            )}
            <ul className="list-group mb-3">
                {query.length > 0 && results.map((result, index) => (
                    <li
                        key={index}
                        className="list-group-item search-result-item"
                        onClick={() => handleClick(result)}
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                    >
                        <img
                            src={result.box_image}
                            alt={result.name_en}
                            style={{  height: '50px', marginRight: '10px' }}
                        />
                        {result.name_en} {result.name_source !== 'name_en' && `(${result.name_orig})`}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SearchField;